"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _testkit = require("../../redux/testkit/testkit.types");

var _Util = require("../util/Util");

var _TestkitAwaitingResultCard = _interopRequireDefault(require("./TestkitAwaitingResultCard"));

var _Username = _interopRequireDefault(require("../../components/username/Username"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const columns = [{
  title: 'ID',
  dataIndex: 'id',
  key: 'id',
  sorter: (a, b) => a.id - b.id
}, {
  title: 'Type',
  dataIndex: 'type',
  key: 'type',
  sorter: (a, b) => `${a.type}`.localeCompare(b.type),
  filters: [{
    text: 'OraQuick',
    value: 'oraquick'
  }, {
    text: 'HEMASPOT',
    value: 'hemaspot'
  }],
  onFilter: (value, record) => record.type.toLowerCase() === value
}, {
  title: 'Request Date',
  dataIndex: 'requestDate',
  key: 'requestDate',
  render: _Util.renderDateWithoutTime,
  sorter: (a, b) => (0, _moment.default)(a.requestDate).unix() - (0, _moment.default)(b.requestDate).unix()
}, {
  title: 'Expiration Date',
  dataIndex: 'requestDate',
  key: 'expirationDate',
  render: (value, row) => (0, _moment.default)(value).add(45, 'day').format('YYYY-MM-DD'),
  sorter: (a, b) => (0, _moment.default)(a.requestDate).unix() - (0, _moment.default)(b.requestDate).unix()
}, {
  title: 'Username',
  dataIndex: 'participant.id',
  key: 'username',
  render: (value, row) => /*#__PURE__*/_react.default.createElement(_Username.default, {
    participantId: value
  }),
  sorter: (a, b) => `${a.participant.username}`.localeCompare(b.participant.username)
}];

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

class TestkitAwaitingResultTable extends _react.PureComponent {
  constructor() {
    super(...arguments);
    this.state = {
      studyId: 1
    };

    this.rowRender = record => {
      return /*#__PURE__*/_react.default.createElement(_TestkitAwaitingResultCard.default, {
        testkit: record
      });
    };
  }

  componentDidMount() {
    const {
      loadAwaitingResultTestkits
    } = this.props;
    loadAwaitingResultTestkits({
      studyId: this.state.studyId
    });
  }

  render() {
    const {
      testkits
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_table.default, {
      columns: columns,
      dataSource: testkits,
      scroll: {
        y: 'calc(100vh - 200px)'
      },
      pagination: false,
      rowClassName: rowClassName,
      rowKey: "id",
      expandedRowRender: this.rowRender
    });
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  testkits: selectors.getAwaitingResultTestkits
});

const mapDispatchToProps = dispatch => {
  return {
    loadAwaitingResultTestkits: args => dispatch(_testkit.getAwaitingResultTestkitsAsync.request(args))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TestkitAwaitingResultTable);

exports.default = _default;